module.exports = __webpack_public_path__ + "static/media/IconTemplates_-42.74cca180.svg";